/* FAQ Exclusive Accordion */
(function () {
  'use strict';

  class KlFaqExclusive extends HTMLElement {
    connectedCallback() {
      // Capture phase required for toggle
      this.addEventListener('toggle', this.onToggle, true);
    }

    disconnectedCallback() {
      this.removeEventListener('toggle', this.onToggle, true);
    }

    onToggle = (event) => {
      if (!event.target.open) {
        return;
      }

      this.querySelectorAll('accordion-disclosure').forEach((accordion) => {
        if (!accordion.contains(event.target) && accordion.querySelector('details[open]')) {
          accordion.close();
        }
      });
    };
  }

  if (!window.customElements.get('kl-faq-exclusive')) {
    window.customElements.define('kl-faq-exclusive', KlFaqExclusive);
  }
})();
